<div class="container">
  <div class="content">
    <div class="top">

      @if (completed) {
        <div class="div">
          <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.14569 0C0.841941 0.000347522 0.550732 0.121165 0.335949 0.335949C0.121165 0.550732 0.000347522 0.841941 0 1.14569V33.8213C0 34.1251 0.120708 34.4166 0.335569 34.6314C0.55043 34.8463 0.841845 34.967 1.1457 34.967C1.44956 34.967 1.74098 34.8463 1.95584 34.6314C2.1707 34.4166 2.29141 34.1251 2.29141 33.8213V1.14569C2.29106 0.841935 2.17024 0.550721 1.95545 0.335937C1.74066 0.121152 1.44944 0.000338084 1.14569 0Z"
              fill="white" />
              <path
                d="M28.2194 16.076C27.8812 15.5529 27.7013 14.9432 27.7013 14.3203C27.7013 13.6974 27.8812 13.0877 28.2194 12.5646L32.1313 6.43208C32.3678 6.07531 32.5009 5.66007 32.5159 5.23232C32.5309 4.80457 32.4272 4.38102 32.2164 4.00855C31.7472 3.15279 30.8127 2.62122 29.7776 2.62122H3.16895V26.0194H29.7775C30.8127 26.0194 31.7472 25.4878 32.2164 24.632C32.4272 24.2596 32.5309 23.836 32.5159 23.4083C32.5009 22.9805 32.3678 22.5653 32.1313 22.2085L28.2194 16.076ZM22.669 12.4183L16.474 18.6064C16.0112 19.0687 15.3838 19.3283 14.7297 19.3281C14.0756 19.3279 13.4483 19.068 12.9857 18.6055L10.0362 15.6559C9.69502 15.3147 9.50332 14.8519 9.50332 14.3694C9.50332 13.8868 9.69502 13.424 10.0362 13.0828C10.2052 12.9139 10.4058 12.7798 10.6265 12.6884C10.8472 12.597 11.0838 12.5499 11.3228 12.5499C11.5617 12.5499 11.7983 12.597 12.019 12.6884C12.2398 12.7798 12.4404 12.9139 12.6093 13.0828L14.1599 14.6335C14.3123 14.7859 14.519 14.8715 14.7345 14.8715C14.95 14.8715 15.1566 14.7859 15.309 14.6335L20.0973 9.84521C20.2662 9.67631 20.4667 9.54232 20.6874 9.45091C20.9081 9.3595 21.1446 9.31245 21.3835 9.31245C21.6223 9.31245 21.8589 9.3595 22.0796 9.45091C22.3002 9.54232 22.5008 9.67631 22.6697 9.84521C22.8386 10.0142 22.9726 10.2148 23.064 10.4356C23.1555 10.6563 23.2025 10.893 23.2024 11.1319C23.2023 11.3709 23.1552 11.6075 23.0637 11.8282C22.9721 12.0489 22.838 12.2494 22.669 12.4183Z"
                fill="white" />π
              </svg>
            </div>
          }

          @if (!completed) {
            <div class="div">
              <svg width="50" height="41" viewBox="0 0 50 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M41.2083 0L50 8.73838L17.5833 41L0 23.5025L8.79167 14.7641L17.5833 23.5025L41.2083 0ZM41.2083 5.79798L17.5833 29.3212L8.79167 20.6864L5.85417 23.5025L17.5833 35.1399L44.1458 8.73838L41.2083 5.79798Z"
                  fill="#89ED5B" />
                </svg>
              </div>
            }

            <div class="title">
              {{title}}
            </div>
            <progress [value]="progress"></progress>
            <div class="text">
              {{mainText}}
            </div>
          </div>
          <div class="bottom">
            <img src="/assets/medal-badge.png" alt="Task Complete Medal">
            <button (click)="close()" class="button">
              {{actionText}}
            </button>
          </div>
        </div>
      </div>